<template>
  <div>
    <!-- FoodMenu Modal -->
    <v-dialog persistent v-model="foodMenuModalVisible" max-width="700">
      <!-- Add / Upload Excel Modal -->
      <v-card v-if="!isDetail">
        <v-card-title class="headline indigo lighten-2 white--text text-center">
          {{ modalHeader }}
        </v-card-title>

        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(handleFormSubmit)">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-alert type="info" dense outlined text>
                    Özel Gün için Excel dosyasındaki 5. kolona "EVET" parametresini ekleyin. Bu bilgi özel gün kaydı için gereklidir.
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-banner rounded outlined>
                    <CompanySelect multiple v-model="selectedGroupIds" />
                    <ValidationProvider name="Dosya" rules="required" v-slot="{ errors }">
                      <v-file-input
                        v-model="excelFile"
                        accept=".xlsx, .xls"
                        ref="fileupload"
                        :rules="[fileSizeRule]"
                        :placeholder="$t('labels.selectExcelFile')"
                        prepend-icon="mdi-file"
                        :label="$t('labels.fileUpload')"
                        @change="onFileChange"
                        :error-messages="errors[0]"
                        show-size
                      />
                    </ValidationProvider>
                  </v-banner>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="sticky-footer">
              <v-spacer />
              <v-btn color="primary" type="submit" :loading="loading.send">
                {{ $t("buttons.save") }}
              </v-btn>
              <v-btn color="primary" text @click="closeModal">
                {{ $t("buttons.close") }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>

      <!-- Detail Modal -->
      <v-card v-else style="overflow-x: hidden;">
        <v-card-title class="headline indigo lighten-2 white--text text-center">
          {{ modalHeader }}
        </v-card-title>

        <v-row align="center" justify="center">
          <v-card class="mx-auto my-12" width="400">
            <v-img height="150" src="https://cdn.vuetifyjs.com/images/cards/cooking.png" />
            <v-card-title
              v-for="(item, index) in detailedItem"
              :key="index"
              class="py-1 px-3"
              style="border-bottom: 1px solid #d9d9d9"
            >
              <div class="text-h6 font-weight-black" style="width: 100%">
                {{ item.Type }}
                <v-list subheader two-line>
                  <v-list-item
                    v-for="(food, i) in item.FoodKind"
                    :key="i"
                    style="min-height: 30px"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ food.Name }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip color="pink" text-color="white" label>
                        {{ food.Calory + ' - ' + $t('labels.foodMenuCalory') }}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-title>
          </v-card>
        </v-row>

        <v-card-actions class="sticky-footer">
          <v-spacer />
          <v-btn color="#7986CB" dark depressed @click="closeDetail">
            {{ $t("buttons.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Food Menu Update -->
    <v-dialog persistent v-model="foodMenuFormModal" max-width="700">
      <!-- Add / Upload Excel Modal -->
      <v-card>
        <v-card-title class="headline indigo lighten-2 white--text text-center">
          Yemek Menüsünü Düzenle
        </v-card-title>

        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(submitFoodMenuForm)">
            <v-card-text>
              <v-row class="pa-4">
                <v-col>
                  <ValidationProvider
                      rules="required"
                      :name="$t('labels.isSpecialDay')"
                      v-slot="{ errors }"
                    >
                      <v-checkbox
                        v-model="foodMenuForm.IsSpecialDay"
                        :label="$t('labels.isSpecialDay')"
                        outlined
                        dense
                        :error-messages="errors[0]"
                      />
                    </ValidationProvider>
                </v-col>
                <v-col
                  cols="12"
                  v-for="(value, index) in foodMenuForm.Food"
                  :key="index"
                >
                  <!-- CARD WRAPPER -->
                  <v-card outlined class="pa-4 mb-4">
                    
                    <!-- HEADER -->
                    <div class="d-flex justify-space-between align-center mb-3">
                      <span class="subtitle-1 font-weight-bold">
                        {{ $t('labels.foodType') }} {{ index + 1 }}
                      </span>
                      <div class="mt-1">
                        <v-btn
                          dark
                          small
                          color="warning"
                          class="mr-2"
                          @click="addNewKind(value.FoodKind)"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn
                          dark
                          small
                          color="error"
                          class="mr-2"
                          @click="foodMenuForm.Food = removeKind(foodMenuForm.Food, index)"
                        >
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <!-- FOOD TYPE -->
                    <ValidationProvider
                      rules="required"
                      :name="$t('labels.foodType')"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="value.Type"
                        :label="$t('labels.foodType')"
                        outlined
                        dense
                        :error-messages="errors[0]"
                      />
                    </ValidationProvider>

                    <!-- FOOD KIND LIST -->
                    <div
                      v-for="(kind, kindIndex) in value.FoodKind"
                      :key="kindIndex"
                      class="mt-3"
                    >
                      <v-row dense>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-for="(food, foodIndex) in Object.entries(kind)"
                          :key="foodIndex"
                        >
                          <ValidationProvider
                            rules="required"
                            :name="$t(`labels.${food[0]}`)"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="kind[food[0]]"
                              :label="$t(`labels.${food[0]}`)"
                              outlined
                              dense
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-col>
                        <v-col class="mt-1">
                          <v-btn
                            dark
                            small
                            color="error"
                            @click="value.FoodKind = removeKind(value.FoodKind, kindIndex)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>

                <!-- ADD BUTTON -->
                <v-col cols="12" class="text-center">
                  <v-btn
                    dark
                    color="success"
                    @click="addNewFoodForm()"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    {{ $t("buttons.addNew") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="sticky-footer">
              <v-spacer />
              <v-btn color="primary" type="submit" :loading="loading.send">
                {{ $t("buttons.save") }}
              </v-btn>
              <v-btn color="primary" text @click="foodMenuFormModal = false">
                {{ $t("buttons.close") }}
              </v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>

    <!-- Delete Modal -->
    <delete-modal :yesFunc="deleteMenus" ref="deleteModalRef" />

    <!-- Main Content -->
    <v-card style="border-radius: 10px">
      <v-card-title>
        <v-row align="center">
          <v-col>{{ $t("title.titleFoodMenu") }}</v-col>
          <v-col cols="6" class="text-right">
            <v-btn small outlined color="info" class="mr-4"
              :href="getFile()" download>
              {{ $t("buttons.sampleFile") }}
            </v-btn>
            <v-btn small outlined color="info" class="mr-4" @click="openDeleteModal" v-if="selectedMenus.length">
              {{ $t("buttons.deleteSelected") }}
            </v-btn>
            <v-btn small outlined color="info" @click="openAddModal">
              {{ $t("buttons.importExcel") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-menu v-model="datePickerVisible" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  :label="$t('labels.selectDate')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="dates" locale="tr-TR" range>
                <v-spacer />
                <v-btn text color="primary" @click="clearDateFilter">
                  {{ $t("buttons.cancel") }}
                </v-btn>
                <v-btn text color="primary" @click="applyDateFilter">
                  {{ $t("buttons.ok") }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="updateItemsPerPage"
            />
          </v-col>
        </v-row>

        <v-data-table
          @click:row="updateFoodMenu"
          :item-class="() => 'clickable-row'"
          v-model="selectedMenus"
          item-key="Id"
          show-select
          :headers="headers"
          :items="tableData"
          :loading="loading.table"
          :options.sync="options"
          :no-data-text="$t('description.noList')"
        >
          <template v-slot:item.Date="{ item }">
            {{ convertToLocal(item.Date) }} tarihli yemek menüsü
          </template>

        <template v-slot:item.IsSpecialDay="{ item }">
          <v-chip
            small
            :color="item.IsSpecialDay ? 'green' : 'grey'"
            :text-color="item.IsSpecialDay ? 'white' : 'white'"
          >
            {{ item.IsSpecialDay ? 'Özel Gün' : 'Normal' }}
          </v-chip>
        </template>

          <template v-slot:item.CreatedAt="{ item }">
            {{ convertToLocal(item.CreatedAt) }}
          </template>

          <template v-slot:item.User="{ item }">
            {{ item.User.Name ? `${item.User.Name} ${item.User.Surname}(${item?.User?.Username})` : item.User.Username }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon color="green" small class="mr-2" @click.stop="updateFoodMenu(item)">mdi-pencil</v-icon>
            <v-icon color="info" small class="mr-2" @click.stop="showDetails(item)">mdi-file-eye</v-icon>
            <v-icon color="error" small @click.stop="openDeleteModal(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>

        <v-pagination
          @input="changePage"
          :value="pagination.page"
          :length="pages"
          :total-visible="10"
          circle
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FoodMenuService from "../services/FoodMenuService";
import DeleteModal from "../components/General/DeleteModal";
import CompanySelect from "../components/CompanySelect.vue";
import { mapActions } from "vuex";
import FileService from "../services/FileService";

export default {
  components: { DeleteModal, CompanySelect },
  data() {
    return {
      url: process.env.VUE_APP_API_URL,
      tableData: [],
      headers: [],
      selectedMenus: [],
      dates: [],
      datePickerVisible: false,
      options: { itemsPerPage: 15 },
      pagination: { totalItems: 0, rowsPerPage: 15, page: 1 },
      itemsPerPage: 15,
      perPageValues: [
        { name: "10", value: 10 },
        { name: "15", value: 15 },
        { name: "30", value: 30 },
        { name: "50", value: 50 },
        { name: "100", value: 100 }
      ],
      excelFile: null,
      selectedGroupIds: [],
      loading: { table: false, send: false },
      foodMenuModalVisible: false,
      isDetail: false,
      detailedItem: [],
      modalHeader: "",

      foodMenuFormModal: false,
      foodMenuForm: {},
      sampleFood: {
        "Type": "string",
        "FoodKind": [
          {
            "Name": "string",
            "Calory": "string"
          }
        ]
      }
    };
  },
  computed: {
    dateRangeText() {
      return this.dates.map(date => convertToLocal(date)).join(" - ");
    },
    pages() {
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage) || 0;
    }
  },
  mounted() {
    this.setupHeaders();
    this.fetchFoodMenus();
  },
  methods: {
    removeKind(kindList, index){
      if(Array.isArray(kindList)){
        return kindList.filter((item, itemIndex) => index !== itemIndex)
      }

      return kindList;
    },
    addNewKind(kindList){
      if(Array.isArray(kindList)){
        kindList.push({ Name: '', Calory: '' })
      }
    },
    addNewFoodForm(){
      window.showSuccess("Başarılı bir şekilde eklendi.")
      this.foodMenuForm?.Food?.push(this.sampleFood)
    },
    submitFoodMenuForm(){
      const foodList = this.foodMenuForm.Food;
      if(Array.isArray(foodList) && foodList.length === 0){
        window.showInfo("En az bir adet yemek türü ekleyiniz.")
        return;
      }

      this.$store.state.loadingStatus = true;
      FoodMenuService.updateMenu(this.foodMenuForm)
      .then(() => {
        this.fetchFoodMenus();
        window.showSuccess('Yemek menüsü başarılı bir şekilde güncellendi.')
      })
      .catch(window.showError)
      .finally(() => this.$store.state.loadingStatus = false)
    },
    updateFoodMenu(item){
      this.foodMenuFormModal = true;
      this.foodMenuForm = Object.assign({}, { Id: item.Id, Food: item.Food, IsSpecialDay: item.IsSpecialDay });
    },

    getFile(){
      return FileService.getFileString(9985)
    },
    ...mapActions(["getMenuData"]),
    setupHeaders() {
      this.headers = [
        { text: this.$t("title.tableHeaderFoodMenuName"), value: "Date" },
        { text: this.$t("title.tableHeaderFoodMenuCreator"), value: "User" },
        { text: this.$t("title.tableHeaderFoodMenuDate"), value: "CreatedAt" },
        { text: this.$t("titles.specialDay"), value: "IsSpecialDay" },
        { text: this.$t("title.tableHeaderActions"), value: "actions", sortable: false }
      ];
    },
    fetchFoodMenus() {
      const [startDate, endDate] = this.dates;
      this.loading.table = true;
      FoodMenuService.getMenus(startDate, endDate, this.pagination.rowsPerPage, this.pagination.page)
        .then(res => {
          this.tableData = res.data.Data.filter(m => !m.DeletedAt);
          this.pagination.totalItems = res.data.TotalData;
        })
        .catch(window.showError)
        .finally(() => this.loading.table = false);
    },
    handleFormSubmit() {
      const formData = new FormData();
      formData.append("File", this.excelFile);
      this.selectedGroupIds.forEach(id => formData.append("GroupIds[]", id));

      this.loading.send = true;
      FoodMenuService.createNewFoodMenuExcel(formData)
        .then(() => {
          this.fetchFoodMenus();
          this.closeModal();
        })
        .catch(window.showError)
        .finally(() => this.loading.send = false);
    },
    onFileChange(file) {
      if (file && file.size > 10000000) {
        alert("Yükleyebileceğiniz maksimum dosya boyutu 10MB olarak belirlenmiştir.");
        this.$refs.fileupload.value = null;
      } else {
        this.excelFile = file;
      }
    },
    fileSizeRule(value) {
      return !value || value.size < 10000000 || "Dosya en fazla 10 MB olmalı.";
    },
    openAddModal() {
      this.modalHeader = this.$t("title.foodMenuModalCreate");
      this.isDetail = false;
      this.foodMenuModalVisible = true;
    },
    showDetails(item) {
      this.detailedItem = [...item.Food];
      this.modalHeader = this.$t("title.foodMenuModalDetail");
      this.isDetail = true;
      this.foodMenuModalVisible = true;
    },
    closeModal() {
      this.$refs.observer?.reset();
      this.$refs.fileupload?.reset();
      this.excelFile = null;
      this.selectedGroupIds = [];
      this.foodMenuModalVisible = false;
    },
    closeDetail() {
      this.isDetail = false;
      this.foodMenuModalVisible = false;
    },
    openDeleteModal(item) {
      if (this.selectedMenus.length || item) {
        this.deleteItemModel = item;
        this.$refs.deleteModalRef.modalStatus = true;
      } else {
        window.showInfo(this.$t("description.invalidMenuSelect"), "standart", "error");
      }
    },
    deleteMenus() {
      const ids = this.selectedMenus.length
        ? this.selectedMenus.map(m => m.Id)
        : [this.deleteItemModel.Id];

      FoodMenuService.deleteMenus({ ids })
        .then(() => {
          this.fetchFoodMenus();
          this.$refs.deleteModalRef.modalStatus = false;
          this.getMenuData();
        })
        .catch(window.showError)
        .finally(() => this.selectedMenus = []);
    },
    changePage(page) {
      this.pagination.page = page;
      this.fetchFoodMenus();
    },
    updateItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.fetchFoodMenus();
    },
    clearDateFilter() {
      this.dates = [];
      this.datePickerVisible = false;
      this.fetchFoodMenus();
    },
    applyDateFilter() {
      this.datePickerVisible = false;
      this.fetchFoodMenus();
    }
  }
};
</script>

<style>
.sticky-footer {
  background-color: white;
  position: sticky;
  bottom: 0;
  border-top: solid grey 2px;
}
</style>
